module.exports = __webpack_public_path__ + "static/_concordiaLogo-ff7406d922ae33d8e5b7e4f9e36d21fd.png";